import { z } from "zod";
import { ShortText, MediumText, idString } from "./common.js";
const FunnelItem = z
    .object({
    id: idString,
    text: MediumText,
})
    .strict();
const FunnelLevel = z
    .object({
    id: idString,
    title: ShortText,
    items: z.array(FunnelItem).max(50),
})
    .strict();
/**
 * Funnel Analysis — Look, multi. Three-level Why-tree from broad
 * symptoms → why questions → actionable root causes. Each level is a
 * colored card with item chips + "N ITEMS" pill.
 */
export const FunnelParamsSchema = z
    .object({
    title: ShortText.optional(),
    levels: z.array(FunnelLevel).length(3),
})
    .strict();
const DEFAULT_TITLES = [
    "Level 1",
    "Why Analysis",
    "Actionable Root Causes",
];
export const defaultFunnelParams = {
    levels: DEFAULT_TITLES.map((title, i) => ({
        id: `lvl-${i + 1}`,
        title,
        items: [],
    })),
};
//# sourceMappingURL=funnel.js.map